// extracted by mini-css-extract-plugin
module.exports = {"module":"EmployeeLoad_module__cWuj8"};